// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logContainer {
  -webkit-user-select: none;
  user-select: none;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e8e9f8;
  height: 100vh;
}

.screen-1 {
  background: #f1f7fe;
  padding: 2em;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: 0 0 2em #e6e9f9;
  gap: 2em;
}

.screen-1 .logo {
  margin-top: -3em;
}

.screen-1 .email {
  background: rgba(255, 255, 255, 0.800);
  box-shadow: 0 0 2em #e6e9f9;
  padding: 0.7em;
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  border-radius: 5px;
  color: #4d4d4d;
  margin-top: -3em;
}

.screen-1 .email input {
  outline: none;
  border: none;
  margin: 5px 0 0 30px;
  width: 85%;
}

.screen-1 input::placeholder {
  color: rgba(0, 0, 0, 0.584);
  font-size: 1.1em;
}

.screen-1 .email ion-icon {
  color: #4d4d4d;
  margin-bottom: -0.2em;
}

.screen-1 .password {
  background: rgba(255, 255, 255, 0.800);
  box-shadow: 0 0 2em #e6e9f9;
  padding: 0.7em;
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  border-radius: 5px;
  color: #4d4d4d;
}

.screen-1 .password input {
  outline: none;
  border: none;
  margin: 5px 0 0 30px;
  width: 85%;
}

.screen-1 .password input::-moz-placeholder {
  color: black;
  font-size: 0.9em;
}

.screen-1 .password input:-ms-input-placeholder {
  color: black;
  font-size: 0.9em;
}

.screen-1 .password .show-hide {
  margin-right: -5em;
}

.screen-1 .login {
  padding: 1em;
  background: #3e4684;
  color: white;
  border: none;
  border-radius: 30px;
  font-weight: 600;
}

.screen-1 .footer {
  display: flex;
  font-size: 0.7em;
  color: #5e5e5e;
  gap: 14em;
  min-width: 300px;
}

.screen-1 .footer span {
  cursor: pointer;
  margin-left: 5px;
}

button {
  cursor: pointer;
}

@keyframes example {
  0% {
    transform: translateX(2px)
  }

  25% {
    transform: translateX(5px)
  }

  50% {
    transform: translateX(-5px)
  }

  75% {
    transform: translateX(5px)
  }

  100% {
    transform: translateX(-3px)
  }
}

h1 {
  text-align: center;
  font-size: 15px;
  color: #D44D5C;
  margin-top: -67px;
  margin-bottom: 30px;
  font-weight: 400;
  animation-name: example;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EAGzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAYA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;AACrC","sourcesContent":[".logContainer {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow-y: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #e8e9f8;\n  height: 100vh;\n}\n\n.screen-1 {\n  background: #f1f7fe;\n  padding: 2em;\n  display: flex;\n  flex-direction: column;\n  border-radius: 15px;\n  box-shadow: 0 0 2em #e6e9f9;\n  gap: 2em;\n}\n\n.screen-1 .logo {\n  margin-top: -3em;\n}\n\n.screen-1 .email {\n  background: rgba(255, 255, 255, 0.800);\n  box-shadow: 0 0 2em #e6e9f9;\n  padding: 0.7em;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3em;\n  border-radius: 5px;\n  color: #4d4d4d;\n  margin-top: -3em;\n}\n\n.screen-1 .email input {\n  outline: none;\n  border: none;\n  margin: 5px 0 0 30px;\n  width: 85%;\n}\n\n.screen-1 .email input::-moz-placeholder {\n  color: black;\n  font-size: 0.9em;\n}\n\n.screen-1 .email input:-ms-input-placeholder {\n  color: black;\n  font-size: 0.9em;\n}\n\n.screen-1 input::placeholder {\n  color: rgba(0, 0, 0, 0.584);\n  font-size: 1.1em;\n}\n\n.screen-1 .email ion-icon {\n  color: #4d4d4d;\n  margin-bottom: -0.2em;\n}\n\n.screen-1 .password {\n  background: rgba(255, 255, 255, 0.800);\n  box-shadow: 0 0 2em #e6e9f9;\n  padding: 0.7em;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3em;\n  border-radius: 5px;\n  color: #4d4d4d;\n}\n\n.screen-1 .password input {\n  outline: none;\n  border: none;\n  margin: 5px 0 0 30px;\n  width: 85%;\n}\n\n.screen-1 .password input::-moz-placeholder {\n  color: black;\n  font-size: 0.9em;\n}\n\n.screen-1 .password input:-ms-input-placeholder {\n  color: black;\n  font-size: 0.9em;\n}\n\n.screen-1 .password .show-hide {\n  margin-right: -5em;\n}\n\n.screen-1 .login {\n  padding: 1em;\n  background: #3e4684;\n  color: white;\n  border: none;\n  border-radius: 30px;\n  font-weight: 600;\n}\n\n.screen-1 .footer {\n  display: flex;\n  font-size: 0.7em;\n  color: #5e5e5e;\n  gap: 14em;\n  min-width: 300px;\n}\n\n.screen-1 .footer span {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n@keyframes example {\n  0% {\n    transform: translateX(2px)\n  }\n\n  25% {\n    transform: translateX(5px)\n  }\n\n  50% {\n    transform: translateX(-5px)\n  }\n\n  75% {\n    transform: translateX(5px)\n  }\n\n  100% {\n    transform: translateX(-3px)\n  }\n}\n\nh1 {\n  text-align: center;\n  font-size: 15px;\n  color: #D44D5C;\n  margin-top: -67px;\n  margin-bottom: 30px;\n  font-weight: 400;\n  animation-name: example;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
